import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';
import AppliedRoute from './components/AppliedRoute';
import NotFound from './containers/NotFound';
import Login from './containers/Login';
import Signup from './containers/Signup';
import Upload from './containers/Upload';
import NewCustomer from './containers/NewCustomer';
import Customers from './containers/Customers';
import Admin from './containers/Admin';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from './containers/Home';

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <AppliedRoute path="/upload/:token" exact component={Upload} props={childProps} />
    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <UnauthenticatedRoute path="/login/sso" exact component={Login} props={childProps} />
    <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
    <AuthenticatedRoute path="/customers/new" exact component={NewCustomer} props={childProps} />
    <AuthenticatedRoute path="/customers/:id" exact component={Customers} props={childProps} />
    <AuthenticatedRoute path="/upload" exact component={Upload} props={childProps} />
    <AuthenticatedRoute path="/admin" exact component={Admin} props={childProps} />
    <Route component={NotFound} />
  </Switch>
);


// WEBPACK FOOTER //
// ./src/Routes.js